'use client';

import { useLocale } from '@dealerportal/i18n/client';
import { FormatDate, isValidURL } from '@dealerportal/utilities';
import classNames from 'classnames';
import type { ArticlePreview } from '../../../../common/src/lib/types/Blog';
import { ReadTime } from './ReadTime';

type Props = {
  article: ArticlePreview;
  blogSlug: string;
  gap?: string;
  imgSize?: string;
};

export function RecentPost(props: Props) {
  const locale = useLocale() as 'en' | 'pt' | 'es';

  const formattedDate = FormatDate(
    new Date(props.article.PublishDate),
    'MMMM dd, yyyy',
    locale
  );

  const featuredImage = props.article.FeaturedImage;

  return (
    <a
      href={`/${props?.article?.BlogSlug}/articles/${props.article.Slug}`}
      className={classNames(
        'recent-posts ui-block !ui-no-underline hover:!ui-no-underline',
        props.gap ? props.gap : 'ui-mt-6'
      )}
    >
      <article className="ui-flex ui-items-center ui-gap-4">
        {featuredImage && isValidURL(featuredImage.ImageURL) && (
          <div
            style={{
              backgroundImage: `url('${featuredImage.ImageURL}')`,
            }}
            className={classNames(
              'recent-posts__img ui-rounded-lg ui-bg-cover ui-bg-left-top ui-bg-no-repeat',
              props.imgSize ? props.imgSize : 'ui-h-24 ui-w-28'
            )}
          />
        )}

        {(!featuredImage || !isValidURL(featuredImage.ImageURL)) && (
          <div
            className={classNames(
              'recent-posts__img --no-image ui-flex ui-items-center ui-justify-center ui-shrink-0 ui-bg-gray-200 ui-rounded-lg',
              props.imgSize ? props.imgSize : 'ui-h-24 ui-w-28'
            )}
          >
            <svg
              className="ui-w-8 ui-fill-gray-400/50"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 512 512"
            >
              <path d="M168 80c-13.3 0-24 10.7-24 24V408c0 8.4-1.4 16.5-4.1 24H440c13.3 0 24-10.7 24-24V104c0-13.3-10.7-24-24-24H168zM72 480c-39.8 0-72-32.2-72-72V112C0 98.7 10.7 88 24 88s24 10.7 24 24V408c0 13.3 10.7 24 24 24s24-10.7 24-24V104c0-39.8 32.2-72 72-72H440c39.8 0 72 32.2 72 72V408c0 39.8-32.2 72-72 72H72zM176 136c0-13.3 10.7-24 24-24h96c13.3 0 24 10.7 24 24v80c0 13.3-10.7 24-24 24H200c-13.3 0-24-10.7-24-24V136zm200-24h32c13.3 0 24 10.7 24 24s-10.7 24-24 24H376c-13.3 0-24-10.7-24-24s10.7-24 24-24zm0 80h32c13.3 0 24 10.7 24 24s-10.7 24-24 24H376c-13.3 0-24-10.7-24-24s10.7-24 24-24zM200 272H408c13.3 0 24 10.7 24 24s-10.7 24-24 24H200c-13.3 0-24-10.7-24-24s10.7-24 24-24zm0 80H408c13.3 0 24 10.7 24 24s-10.7 24-24 24H200c-13.3 0-24-10.7-24-24s10.7-24 24-24z" />
            </svg>
          </div>
        )}

        <div className="ui-flex-1">
          <h3 className="recent-posts__heading !ui-text-base !ui-leading-snug !ui-font-semibold !ui-text-left !ui-text-gray-950">
            {props.article.ArticleName}
          </h3>

          <div className="recent-posts__info ui-mt-1.5 ui-text-sm ui-text-gray-600 ui-font-normal">
            <time
              dateTime={props.article.PublishDate}
              className="ui-font-semibold"
            >
              {formattedDate}
            </time>
            {/* <ReadTime markup={props.article.Markup} /> */}
          </div>
        </div>
      </article>
    </a>
  );
}

export default RecentPost;
